<template>
	<div v-html="html"></div>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import axios from 'axios';

export default {
	data() {
		return {html: undefined}
	},
	computed: {
		...mapState(['baseUrl', 'publicationsListHtml']),
		...mapGetters(['page', 'areaUrlCode'])
	},
	watch: {
		page() {
			this.updateList();
		},
		areaUrlCode() {
			this.updateList();
		},
		async html() {
			await this.$nextTick();	
			$("html, body").stop().animate({scrollTop:0}, 500, 'swing', () => {
				viewportCheck($('.scroll-animate', this.$el));
			});	
		}
	},
	methods: {
		async updateList() {
			const url = `${this.baseUrl}1210/subindex`;
			const page = this.page;
			const areaUrlCode = this.areaUrlCode;
			const resp = await axios.get(url, {
				params: {page, areaUrlCode}
			});
			if (page != this.page || areaUrlCode != this.areaUrlCode) return;
			this.html = resp.data;
			this.$store.commit('pageCount', parseInt(resp.headers['x-page-count']));
		}
	},
	created() {
		this.html = this.publicationsListHtml;		
		this.updateList();
	}
}
</script>
